import React, { PureComponent } from 'react';
import Autosuggest from 'react-autosuggest';
import SearchManager from '../managers/SearchManager';

class SearchBar extends PureComponent {
  constructor() {
    super();
    this.searcher = new SearchManager();
    this.state = {
      value: '',
      suggestions: [],
    };
  }

  onChange = (event, { newValue }) => {
    console.log(newValue);
    const { emptySearch } = this.props;
    if (newValue === '') {
      emptySearch();
    }

    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    const { searchPage } = this.props;
    const projects = this.searcher.setupProjectsForSlide(value);
    searchPage(projects);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: this.searcher.getPlaceHolder(),
      value,
      onChange: this.onChange,
      type: 'search',
    };

    const theme = {
      container: 'react-autosuggest__container',
      containerOpen: 'react-autosuggest__container--open',
      input: 'font-title-medium search--input',
      inputOpen: 'react-autosuggest__input--open',
      inputFocused: 'react-autosuggest__input--focused',
      suggestionsContainer: 'react-autosuggest__suggestions-container',
      suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
      suggestionsList: 'react-autosuggest__suggestions-list',
      suggestion: 'react-autosuggest__suggestion',
      suggestionFirst: 'react-autosuggest__suggestion--first',
      suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
      sectionContainer: 'react-autosuggest__section-container',
      sectionContainerFirst: 'react-autosuggest__section-container--first',
      sectionTitle: 'react-autosuggest__section-title',
    };

    const renderInputComponent = inputs => (
      <div className="search">
        <input {...inputs} />
        <div className={!value ? 'search--hourglass' : ''} />
      </div>
    );

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={suggestion => suggestion.title}
        renderSuggestion={suggestion => <div>{suggestion.title}</div>}
        inputProps={inputProps}
        renderInputComponent={renderInputComponent}
        theme={theme}
      />
    );
  }
}
export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js